import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import {
  Alert, Box, Button, Container, FormControl, InputLabel, Link, MenuItem,
  Paper, Select, Step, StepLabel, Stepper, TextField, Typography
} from '@mui/material';
import { api } from '../services/AuthService';

const steps = ['Responsavel', 'Estabelecimento', 'Acesso'];

export default function StoreSignup() {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    owner_name: '', store_name: '', document: '', phone: '', address: '',
    cep: '', city: '', type: 'lanchonete', email: '', password: '', confirmPassword: ''
  });

  const set = (field) => (event) => setForm((current) => ({ ...current, [field]: event.target.value }));

  const next = () => {
    setError('');
    if (activeStep === 0 && (!form.owner_name || !form.phone || !form.document)) {
      return setError('Preencha nome, telefone e CPF/CNPJ.');
    }
    if (activeStep === 1 && (!form.store_name || !form.address || !form.city)) {
      return setError('Preencha os dados do estabelecimento.');
    }
    setActiveStep((step) => step + 1);
  };

  const submit = async (event) => {
    event.preventDefault();
    if (form.password !== form.confirmPassword) return setError('As senhas nao conferem.');
    setLoading(true);
    setError('');
    try {
      const { data } = await api.post('/onboarding/register', form);
      localStorage.setItem('@DeliveryAdmin:token', data.token);
      localStorage.setItem('@DeliveryAdmin:refreshToken', data.refreshToken);
      localStorage.setItem('@DeliveryAdmin:user', JSON.stringify(data.user));
      api.defaults.headers.common.Authorization = `Bearer ${data.token}`;
      navigate('/onboarding', { replace: true });
      window.location.reload();
    } catch (requestError) {
      setError(requestError.response?.data?.error || 'Nao foi possivel criar sua loja.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fff7ed', py: { xs: 3, md: 7 } }}>
      <Container maxWidth="md">
        <Paper sx={{ p: { xs: 2.5, md: 5 }, borderRadius: 4 }}>
          <Typography variant="h4" fontWeight={900} textAlign="center">Crie seu delivery</Typography>
          <Typography color="text.secondary" textAlign="center" sx={{ mt: 1, mb: 4 }}>
            30 dias grátis. Depois, R$ 59,90/mês e 2% somente nos pagamentos online. Cancele quando quiser.
          </Typography>
          <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
            {steps.map((label) => <Step key={label}><StepLabel>{label}</StepLabel></Step>)}
          </Stepper>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Box component="form" onSubmit={submit} sx={{ display: 'grid', gap: 2 }}>
            {activeStep === 0 && <>
              <TextField required label="Seu nome" value={form.owner_name} onChange={set('owner_name')} />
              <TextField required label="WhatsApp" value={form.phone} onChange={set('phone')} />
              <TextField required label="CPF ou CNPJ" value={form.document} onChange={set('document')} />
            </>}
            {activeStep === 1 && <>
              <TextField required label="Nome do estabelecimento" value={form.store_name} onChange={set('store_name')} />
              <FormControl>
                <InputLabel>Tipo</InputLabel>
                <Select label="Tipo" value={form.type} onChange={set('type')}>
                  <MenuItem value="lanchonete">Lanchonete</MenuItem>
                  <MenuItem value="restaurante">Restaurante</MenuItem>
                  <MenuItem value="pizzaria">Pizzaria</MenuItem>
                  <MenuItem value="sorveteria">Sorveteria</MenuItem>
                  <MenuItem value="acai">Acai</MenuItem>
                  <MenuItem value="farmacia">Farmacia</MenuItem>
                </Select>
              </FormControl>
              <TextField required label="Endereco completo" value={form.address} onChange={set('address')} />
              <Box sx={{ display: 'grid', gridTemplateColumns: { sm: '1fr 2fr' }, gap: 2 }}>
                <TextField label="CEP" value={form.cep} onChange={set('cep')} />
                <TextField required label="Cidade" value={form.city} onChange={set('city')} />
              </Box>
            </>}
            {activeStep === 2 && <>
              <TextField required type="email" label="E-mail de acesso" value={form.email} onChange={set('email')} />
              <TextField required type="password" label="Senha (minimo 8 caracteres)" value={form.password} onChange={set('password')} />
              <TextField required type="password" label="Confirmar senha" value={form.confirmPassword} onChange={set('confirmPassword')} />
              <Alert severity="info">Sua loja sera criada em modo teste e so aparecera aos clientes quando voce publicar.</Alert>
            </>}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
              <Button disabled={activeStep === 0 || loading} onClick={() => setActiveStep((step) => step - 1)}>Voltar</Button>
              {activeStep < steps.length - 1
                ? <Button variant="contained" onClick={next}>Continuar</Button>
                : <Button variant="contained" type="submit" disabled={loading}>{loading ? 'Criando...' : 'Criar minha loja'}</Button>}
            </Box>
          </Box>
          <Typography textAlign="center" variant="body2" sx={{ mt: 3 }}>
            Ja tem conta? <Link component={RouterLink} to="/admin">Entrar no painel</Link>
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}
